__turbopack_context__.v({
  "className": "clarafont_f8b10c18-module__g5Ww_W__className",
  "variable": "clarafont_f8b10c18-module__g5Ww_W__variable",
});
